import { CurrencyModel, LanguageModel } from "@insite/client-framework/Types/ApiModels";

export function parseCurrencyString(currency: string): number {
    let cleanString = currency.replace(/[^0-9.,]+/g, ""); // Clean up string

    // Determine that the format uses comma or dot as the decimal separator
    const hasComma = cleanString.includes(",");
    const hasDot = cleanString.includes(".");

    let decimalSeparator;

    if (hasComma && hasDot) {
        if (cleanString.lastIndexOf(",") > cleanString.lastIndexOf(".")) {
            decimalSeparator = ",";
        } else {
            decimalSeparator = ".";
        }
    } else if (hasComma) {
        decimalSeparator = ",";
    } else {
        decimalSeparator = ".";
    }

    // Remove thousand separators
    if (decimalSeparator === ",") {
        cleanString = cleanString.replace(/\.(?=\d{3})/g, ""); // Remove dots if using comma as decimal separator
    } else {
        cleanString = cleanString.replace(/,(?=\d{3})/g, ""); // Remove commas if using dot as decimal separator
    }

    // Replace decimal separator with a dot for correct parsing in JavaScript
    cleanString = cleanString.replace(decimalSeparator, ".");

    // Parse the cleaned string to a float number
    return parseFloat(cleanString);
}

export const formatNumberToCurrencyString = (
    number: number,
    language: LanguageModel | undefined,
    currency: CurrencyModel | undefined,
) => {
    // Defaults on French, however prices are not available when logged out so it will be defined
    const currencySymbolPosition = language?.currencyPositioning || "Left";
    const currencySymbol = currency?.currencySymbol || "$";
    let formattedNumber = number
        .toLocaleString(language?.languageCode || "fr-CA", {
            style: "currency",
            currency: currency?.currencyCode || "CAD",
            maximumFractionDigits: 2,
        })
        // Adjust for non-standard G-TECH price formats
        .replace(/[a-zA-Z]/g, "")
        .replace(currencySymbol, "");
    if (currencySymbolPosition === "Left") {
        formattedNumber = `${currencySymbol}${formattedNumber}`;
    }
    if (currencySymbolPosition === "Right") {
        formattedNumber = `${formattedNumber}${currencySymbol}`;
    }
    return formattedNumber.trim();
};

export const toFixedFloat = (num: number, decimals: number): number => {
    const factor = 10 ** decimals;
    return Math.round(num * factor) / factor;
};

export const reduceCurrency = (
    original: string | number,
    reduction: string | number,
    language?: LanguageModel,
    currency?: CurrencyModel,
): string | number => {
    const reductionNumber = typeof reduction === "string" ? parseCurrencyString(reduction) : reduction;
    if (reductionNumber === 0) {
        return original;
    }
    const originalNumber = typeof original === "string" ? parseCurrencyString(original) : original;
    const resultNumber = originalNumber - reductionNumber;
    return typeof original === "string"
        ? formatNumberToCurrencyString(resultNumber, language, currency)
        : toFixedFloat(resultNumber, 2);
};
